import { PersonInfo } from 'types/electionService';
import { SubscriberElectionPresenter, SubscriberPresenter } from 'store/modules/elections/types';
import { SubscriberBasicInfo } from 'store/modules/subscriber/subscriber-basic-info/types';

/**
 * SubscriberCard view model: election rows from elections, primary + dependents from basic-info.
 */
export function createElectionsCardPresenter(
  election: SubscriberElectionPresenter,
  basicInfo: SubscriberBasicInfo,
): SubscriberPresenter {
  return {
    id: election.id,
    employeeClass: election.employeeClass,
    choice: election.choice,
    interestedProductLines: election.interestedProductLines,
    productLineToCarrier: election.productLineToCarrier,
    common: { ...basicInfo.primary } as PersonInfo,
    custom: { dependents: basicInfo.dependents as PersonInfo[] },
  };
}
